import * as React from "react";

const SvgUnchainedEvent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <mask
      id="unchained_event_svg__a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="currentColor" fillOpacity={0.92} d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#unchained_event_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m18.435 8.146 1.414-1.414-2.829-2.829q-1.467-1.467-3.535-1.467-2.07 0-3.536 1.467T8.482 7.44q0 2.068 1.467 3.535l1.252 1.29 1.437-1.385-1.275-1.319a2.9 2.9 0 0 1-.883-2.121q0-1.237.883-2.122a2.9 2.9 0 0 1 2.122-.884q1.238 0 2.121.884zM5.565 9.49l-1.414 1.414 5.657 5.657 1.414-1.414zm.708 6.364-1.415 1.414 2.829 2.829q1.467 1.467 3.535 1.467 2.07 0 3.536-1.467t1.467-3.536q0-2.068-1.467-3.535l-1.252-1.29-1.437 1.385 1.275 1.319q.883.884.883 2.121t-.883 2.122-2.122.884a2.9 2.9 0 0 1-2.121-.884z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default SvgUnchainedEvent;
